import React, { useState, useEffect } from 'react';

const SplashIntro = ({ onComplete }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Auto-complete after 1.5s
    const timer = setTimeout(() => { setVisible(false); onComplete(); }, 1500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!visible) return null;

  return (
    <div data-testid="splash-intro" className="fixed inset-0 z-[100] bg-black flex items-center justify-center overflow-hidden"
      style={{ animation: 'splashFade 1.5s ease-in-out forwards' }}>
      <style>{`
        @keyframes splashFade {
          0% { opacity: 1; }
          70% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes splashBeat {
          0%, 100% { transform: scale(1); }
          15% { transform: scale(1.08); }
          30% { transform: scale(1); }
          45% { transform: scale(1.05); }
          60% { transform: scale(1); }
        }
      `}</style>
      <div className="text-center" style={{ animation: 'splashBeat 1.2s ease-in-out' }}>
        <h1 className="text-2xl md:text-4xl font-black text-[#00FF41] tracking-tighter"
          style={{ textShadow: '0 0 40px rgba(0,255,65,0.4), 0 0 80px rgba(0,255,65,0.2)', fontFamily: "'JetBrains Mono', monospace" }}>
          &lt;/AI_covo.tech&gt;<sup style={{ fontSize: '0.3em', verticalAlign: 'super', marginLeft: '2px', fontWeight: 400, fontFamily: 'Georgia, serif' }}>&reg;</sup>
        </h1>
        <p className="font-mono text-sm mt-4 tracking-[0.3em] text-white font-bold">DIGITAL HUB SOCIALE</p>
      </div>
      <button
        onClick={() => { setVisible(false); onComplete(); }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white font-mono text-sm tracking-[0.3em] uppercase border border-white/60 hover:border-white px-6 py-2 hover:bg-white/10 font-bold transition-all"
        data-testid="skip-splash"
      >
        SKIP
      </button>
    </div>
  );
};

export default SplashIntro;
